import React from "react";
import { View } from "react-native";

type PhoneProps = {
  color?: string;
};

const Phone: React.FC<PhoneProps> = ({ color = "#17191D" }) => {
  return (
    <View>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_14342_3748)">
          <path
            d="M17 18H7V6H17V7H19V3C19 1.9 18.1 1 17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V17H17V18ZM7 3H17V4H7V3ZM17 21H7V20H17V21Z"
            fill={color}
          />
          <path
            d="M20.38 9.62L21 11L21.62 9.62L23 9L21.62 8.38L21 7L20.38 8.38L19 9L20.38 9.62Z"
            fill="#33363F"
          />
          <path
            d="M16 8L14.75 10.75L12 12L14.75 13.25L16 16L17.25 13.25L20 12L17.25 10.75L16 8Z"
            fill="#33363F"
          />
          <path
            d="M21 13L20.38 14.38L19 15L20.38 15.62L21 17L21.62 15.62L23 15L21.62 14.38L21 13Z"
            fill="#33363F"
          />
        </g>
        <defs>
          <clipPath id="clip0_14342_3748">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </View>
  );
};

export default Phone;
